// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"6":"c5f217f1","287":"68691c5f","319":"67379647","408":"e678213a","700":"a3ad710c","727":"c0fa4172","783":"68aad8c2","792":"3cff3811","836":"77f768fc","876":"46e16063"}[chunkId] + ".js";
};